import React, { useEffect, useState } from 'react'
import firstStepsApi from '../../utils/firstStepsApi'
import KitList from './KitList'

const KitContent = () => {
    const [items, setItems] = useState([])
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)

    useEffect(() => {
        const fetch = async () => {
            setLoading(true)
            try {
                const contentKitItems = await firstStepsApi.getContentKitItems()
                setItems(contentKitItems)
            }
            catch (err) {
                setError(err)
            }
            finally {
                setLoading(false)
            }
        }
        fetch()
    }, [])

    return (
        <KitList
            title="תכולת ערכת הריון ולידה מוצצים"
            items={items}
            loading={loading}
            error={error}
        />
    )
}

export default KitContent
